if (!customElements.get('media-lightbox-opener')) {
  customElements.define(
    'media-lightbox-opener',
    class MediaLightboxOpener extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', () => {
          const mediaLightbox = document.querySelector(this.getAttribute('data-media-lightbox'));
          if (mediaLightbox) mediaLightbox.show(button);
        });
      }
    }
  );
}

if (!customElements.get('media-lightbox')) {
  customElements.define(
    'media-lightbox',
    class MediaLightbox extends HTMLElement {
      constructor() {
        super();
      }

      get button() {
        return this.querySelector('[id^="MediaLightboxClose-"]');
      }
    
      get overlay() {
        return this.querySelector('[id^="MediaLightbox-Overlay-"]');
      }

      get breakpoint() {
        return this.dataset.breakpoint
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        this.elements = Array.from(document.body.children).filter(element => element.id == this.getAttribute('id'));
        this.elements.length > 0 ? this.remove() : document.body.appendChild(this);
      }

      bindEvents() {
        this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.hide());
        this.overlay?.addEventListener('click', this.hide.bind(this));
        this.button?.addEventListener('click', this.hide.bind(this, false));
        const debouncedOnChange = debounce(() => () => {
          const mainLayout = this.querySelector('.media-lightbox__gallery-main');
          if (window.matchMedia(convertBreakpoint(this.breakpoint)).matches && mainLayout) this.style.setProperty('--media-max-height', `${mainLayout.offsetHeight}px`);
        }, ON_CHANGE_DEBOUNCE_TIMER);
        debouncedOnChange();
        window.addEventListener('resize', debouncedOnChange.bind(this));
      }

      loadContent(template, index) {
        if(!template) return;
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(template.content.firstElementChild.cloneNode(true));
          template.parentNode.appendChild(content.firstElementChild);
          const mainLayout = this.querySelector('.media-lightbox__gallery-main');
          if (!mainLayout) return;
          if (window.matchMedia(convertBreakpoint(this.breakpoint)).matches && mainLayout) this.style.setProperty('--media-max-height', `${mainLayout.offsetHeight}px`);
          mainLayout.querySelector('theme-swiper')?.setActiveSlideItem(index);
          this.setAttribute('loaded', true);
        } else {
          const mainLayout = this.querySelector('.media-lightbox__gallery-main');
          if (!mainLayout) return;
          if (window.matchMedia(convertBreakpoint(this.breakpoint)).matches && mainLayout) this.style.setProperty('--media-max-height', `${mainLayout.offsetHeight}px`);
          mainLayout.querySelector('theme-swiper')?.setActiveSlideItem(index);
        }
        this.enableZoomOnHover(2);
      }

      show(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const templatePopup = this.querySelector('.template-popup');
        if (templatePopup) this.loadContent(templatePopup, triggeredBy.dataset.mediaLightboxIndex);
        setTimeout(() => {
          this.setAttribute('open', '');
          this.classList.add('animate', 'active');
          setScrollbarWidth();
          document.body.classList.add('modal-show', 'media-modal-show', 'overflow-hidden');
        }, this.delay);
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
      }
    
      hide() {
        this.removeAttribute('open');
        this.classList.remove('animate', 'active');
        document.body.classList.remove('modal-show', 'media-modal-show', 'overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        removeTrapFocus(this.activeElement);
        window.pauseAllMedia();
      }
    
      setActiveElement(element) {
        this.activeElement = element;
      }

      // create a container and set the full-size image as its background
      createImageContainer(image) {
        const _image = document.createElement('img');
        _image.setAttribute('src', `${image.src}`);
        const container = document.createElement('div');
        this.prepareImageContainer(container, _image);

        image.style.opacity = '50%';
        _image.onload = () => {
          image.parentElement.insertBefore(container, image);
          image.style.opacity = '100%';
        };

        return container;
      }

      prepareImageContainer(container, image) {
        container.setAttribute('class', 'image-magnify-full-size');
        container.setAttribute('aria-hidden', 'true');
        container.style.backgroundImage = `url('${image.src}')`;
        container.style.backgroundColor = 'var(--gradient-background)';
      }

      moveWithHover(image, event, zoomRatio) {
        // calculate mouse position
        const ratio = image.height / image.width;
        const container = event.target.getBoundingClientRect();
        const xPosition = event.clientX - container.left;
        const yPosition = event.clientY - container.top;
        const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
        const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

        // determine what to show in the frame
        this.container.style.backgroundPosition = `${xPercent} ${yPercent}`;
        this.container.style.backgroundSize = `${image.width * zoomRatio}px`;
      }

      magnify(image, zoomRatio) {
        this.container = this.createImageContainer(image);
        this.container.onclick = () => this.container.remove();
        this.container.onmousemove = (event) => this.moveWithHover(image, event, zoomRatio);
        // this.container.onmouseleave = () => this.container.remove();
      }

      enableZoomOnHover(zoomRatio) {
        const images = document.querySelectorAll('.image-magnify-hover');
        images.forEach((image) => {
          image.onclick = (event) => {
            this.magnify(image, zoomRatio);
            this.moveWithHover(image, event, zoomRatio);
          };
        });
      }
    }
  );
}